export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_03.0cc0f8fc.jpg";